import script from "./PaymentCompletePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentCompletePage.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentCompletePage.vue?vue&type=style&index=0&id=038b1ede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038b1ede"]])

export default __exports__